export default __webpack_public_path__ + "static/media/Brigand's Straps of World's Edge.65c80b72.jpg";